var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"noselect",class:_vm.IsDark ? 'Dark' : 'mx-dialog',attrs:{"title":_vm.config.Title || _vm.title || '提示',"visible":_vm.show,"width":_vm.config.Width || '550px',"append-to-body":true},on:{"close":_vm.handleClose}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }